<template>
	<div :class="classNames+ '_text'">
		<div v-if="data.card_data">
			<p v-for="item of data.card_data">
				{{item.label}}:{{item.value}}
			</p>
		</div>
		<div v-else>你收到一条留资卡片消息，请打开抖音app查看</div>
	</div>
</template>
<script>
	export default {
		props: {
			data: {
				type: Object,
				default: () => ({
				})
			},
		},
		data() {
			return {
				classNames: 'messageItem',
			}
		},
		methods: {
			
		}
	}
</script>
<style src="./chat-message.less" lang="less" scoped>
</style>
